module.exports = __webpack_public_path__ + "img/store_credit.a1abece.svg";